/* eslint-disable */
import React, { Component } from 'react';
import { withFormik } from 'formik';
import httpService from '../../../api/httpLocationService';
import './UncompletedOrderForm.sass';

class UncompletedOrderForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailIsValid: false,
      name: '',
      firm: '',
      email: '',
      phone: '',
      comments: '',
    };


    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputEmailChange = this.handleInputEmailChange.bind(this);
  }

  validateEmail = (email) => {
    /* eslint-disable max-len, no-useless-escape */
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    /* eslint-disable max-len, no-useless-escape */

    return re.test(String(email).toLowerCase());
  };

  handleInputEmailChange(event) {
    const {value} = event.target;
    const isValid = this.validateEmail(value);

    this.setState({
      emailIsValid: isValid,
      email: value,
    });
  }

  handleInputChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }

  render() {
    const {
      values,
      touched,
      errors,
      handleChange,
      handleBlur,
      handleSubmit,
      formAuthToken,
    } = this.props;

    return (
      <div>
        <form
          name="orderEmailForm"
          className="order-form"
          id="order-email-form"
          onSubmit={handleSubmit}
        >
          <input
            name="authenticity_token"
            value={formAuthToken}
            type="hidden"
          />

          <div className="form-group">
            <label htmlFor="name">{I18n.t('sidebar.order.form.name')}</label>
            <input
              name="name"
              type="text"
              value={values.name}
              id="name"
              onBlur={(e) => {
                handleBlur(e);
              }}
              onChange={(e) => {
                handleChange(e);
                this.handleInputChange(e);
              }}
              className={
                touched.name ? (errors.name ? 'error' : 'is-valid') : null
              }
            />

            <div className="validation-message">
              {touched.name && errors.name ? errors.name : null}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="firm">{I18n.t('sidebar.order.form.company')}</label>
            <input
              name="firm"
              id="firm"
              type="text"
              value={values.firm}
              onBlur={(e) => {
                handleBlur(e);
              }}
              onChange={(e) => {
                handleChange(e);
                this.handleInputChange(e);
              }}
              className={
                touched.firm ? (errors.firm ? 'error' : 'is-valid') : null
              }
            />

            <div className="validation-message">
              {touched.firm && errors.firm ? errors.firm : null}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="email">{I18n.t('sidebar.order.form.email')}</label>
            <input
              name="email"
              value={values.email}
              id="email"
              type="text"
              onBlur={(e) => {
                handleBlur(e);
              }}
              onChange={(e) => {
                handleChange(e);
                this.handleInputEmailChange(e);
              }}
              className={
                touched.email ? (errors.email ? 'error' : 'is-valid') : null
              }
            />

            <div className="validation-message">
              {touched.email && errors.email ? errors.email : null}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="phone">
              {I18n.t('sidebar.order.form.phone')}
              &nbsp;
              {I18n.t('sidebar.order.form.phone_country_code')}
            </label>
            <input
              name="phone"
              value={values.phone}
              id="phone"
              onBlur={(e) => {
                handleBlur(e);
              }}
              onChange={(e) => {
                handleChange(e);
                this.handleInputChange(e);
              }}
              className={
                touched.phone ? (errors.phone ? 'error' : 'is-valid') : null
              }
            />

            <div className="validation-message">
              {touched.phone && errors.phone ? errors.phone : null}
            </div>
          </div>

          <label htmlFor="comments">{I18n.t('sidebar.order.form.comments')}</label>
          <textarea
            name="comments"
            value={values.comments}
            onChange={(e) => {
              handleChange(e);
              this.handleInputChange(e);
            }}
          />

          <div className="form-group">
            <button className="form-email-submit" type="submit">
              {I18n.t('sidebar.order.errors.request_information')}
            </button>
          </div>
        </form>
      </div>
    );
  }
}


const ValidateOrderEmailForm = withFormik({
  mapPropsToValues: bag => ({
    name: bag.orderData.person_name, email: bag.orderData.email, firm: bag.orderData.company_name, phone: bag.orderData.phone_number, comments: '',
  }),

  validate: (values) => {
    const errors = {};

    if (!values.name) {
      errors.name = I18n.t('sidebar.order.form.required-field');
    }
    if (!values.firm) {
      errors.firm = I18n.t('sidebar.order.form.required-field');
    }

    if (!values.email) {
      errors.email = I18n.t('sidebar.order.form.required-field');
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        values.email,
      )
    ) {
      errors.email = I18n.t('sidebar.order.form.invalid-email');
    }

    if (!values.phone) {
      errors.phone = I18n.t('sidebar.order.form.required-field');
    } else if (
      !/^\+?([\d]*\d){10,}$/i.test(
        values.phone.replace(/[-\s()]/g, ''),
      )
    ) {
      errors.phone = I18n.t('sidebar.order.form.invalid-phone');
    }

    return errors;
  },

  handleSubmit: (values, bag) => {
    const {
      name, email, firm, phone, comments,
    } = values;
    //
    const data = {
      name,
      firm,
      email,
      phone,
      authenticity_token: bag.props.formAuthToken,
      location_ids: bag.props.orderData.location_ids,
      comments: comments || '',
    };


    httpService.finishUncompletedOrder(data)
      .then((response) => {
        window.location.replace(response.redirect);
      });
  },

  displayName: 'OrderEmailForm', // helps with React DevTools
})(UncompletedOrderForm);


export default ValidateOrderEmailForm;
